/* ============================================================
   Fabians Südtiroler Feinkost — theme interactions
   Native Shopify AJAX cart + UI behaviours
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = (window.themeMoneyFormat || '€{{amount}}');
    const withDecimals = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDecimals = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return fmt.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (m, token) => {
      return token.indexOf('no_decimals') !== -1 ? noDecimals : withDecimals;
    });
  };

  /* ---------- Toast ---------- */
  function ensureToastHost() {
    let host = document.querySelector('.toast-host');
    if (!host) { host = document.createElement('div'); host.className = 'toast-host'; document.body.appendChild(host); }
    return host;
  }
  function toast(msg) {
    const host = ensureToastHost();
    const el = document.createElement('div');
    el.className = 'toast';
    el.textContent = msg;
    host.appendChild(el);
    requestAnimationFrame(() => el.classList.add('show'));
    setTimeout(() => { el.classList.remove('show'); setTimeout(() => el.remove(), 300); }, 2600);
  }
  window.themeToast = toast;

  /* ---------- Header scroll ---------- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile menu ---------- */
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Cart drawer ---------- */
  const overlay = document.querySelector('[data-cart-overlay]');
  const drawer = document.querySelector('[data-cart-drawer]');

  function openCart() {
    if (!drawer) return;
    overlay && overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    overlay && overlay.classList.remove('is-open');
    drawer && drawer.classList.remove('is-open');
    drawer && drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.openCartDrawer = openCart;
  window.closeCartDrawer = closeCart;

  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); closeCart(); }));
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    const body = drawer && drawer.querySelector('[data-cart-body]');
    const footer = drawer && drawer.querySelector('[data-cart-footer]');
    const sub = drawer && drawer.querySelector('[data-cart-subtitle]');
    if (!body) return;
    const T = window.themeStrings || {};
    if (sub) sub.textContent = cart.item_count === 0 ? (T.cartEmpty || 'Ihr Warenkorb ist leer') : (cart.item_count + ' ' + (T.cartItems || 'Artikel im Warenkorb'));

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><p>' + (T.cartEmpty || 'Ihr Warenkorb ist leer') + '</p></div>';
      if (footer) footer.hidden = true;
      return;
    }
    if (footer) footer.hidden = false;

    body.innerHTML = cart.items.map(item => {
      const variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="variant">' + item.variant_title + '</p>' : '';
      const img = item.image ? '<img src="' + item.image.replace(/(\.[^.\/]+)(\?|$)/, '_160x$1$2') + '" alt="' + item.product_title + '">' : '';
      return '<div class="cart-line" data-key="' + item.key + '">' +
        '<div class="thumb">' + img + '</div>' +
        '<div class="info"><h4>' + item.product_title + '</h4>' + variant +
        '<p class="line-price">' + money(item.final_line_price) + '</p></div>' +
        '<div class="controls">' +
        '<button class="remove" data-remove aria-label="Entfernen"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>' +
        '<div class="qty"><button data-dec aria-label="Weniger">−</button><span>' + item.quantity + '</span><button data-inc aria-label="Mehr">+</button></div>' +
        '</div></div>';
    }).join('');

    const totalEl = drawer.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);

    body.querySelectorAll('.cart-line').forEach(line => {
      const key = line.getAttribute('data-key');
      const item = cart.items.find(i => i.key === key);
      line.querySelector('[data-inc]').addEventListener('click', () => changeLine(key, item.quantity + 1));
      line.querySelector('[data-dec]').addEventListener('click', () => changeLine(key, item.quantity - 1));
      line.querySelector('[data-remove]').addEventListener('click', () => changeLine(key, 0));
    });
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await res.json();
    renderCart(cart);
  }

  async function refreshCart() {
    try { renderCart(await getCart()); } catch (e) { /* noop */ }
  }

  async function addToCart(formOrId, quantity) {
    let body;
    if (typeof formOrId === 'object' && formOrId instanceof HTMLFormElement) {
      body = new FormData(formOrId);
    } else {
      body = JSON.stringify({ items: [{ id: formOrId, quantity: quantity || 1 }] });
    }
    const opts = { method: 'POST', headers: { 'Accept': 'application/json' } };
    if (typeof body === 'string') { opts.headers['Content-Type'] = 'application/json'; opts.body = body; }
    else { opts.body = body; }
    const res = await fetch('/cart/add.js', opts);
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      toast(err.description || 'Nicht möglich.');
      return null;
    }
    const added = await res.json();
    await refreshCart();
    return added;
  }
  window.themeAddToCart = addToCart;

  /* ---------- Product add-to-cart forms ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const label = btn && btn.querySelector('[data-btn-label]');
      const original = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = '…';
      const added = await addToCart(form);
      if (btn) btn.disabled = false;
      if (label) label.textContent = original;
      if (added) {
        const T = window.themeStrings || {};
        toast((added.product_title || '') + ' ' + (T.addedToCart || 'liegt im Warenkorb!'));
        openCart();
      }
    });
  });

  /* ---------- Quick add (cards) ---------- */
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      // Karte ist klickbar — verhindern, dass der Klick zur Produktseite durchschlägt
      e.preventDefault();
      e.stopPropagation();
      const id = btn.getAttribute('data-quick-add');
      btn.disabled = true;
      btn.classList.add('is-loading');
      const added = await addToCart(id, 1);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (added) {
        const title = added.product_title ? added.product_title + ' ' : '';
        toast(title + ((window.themeStrings && window.themeStrings.addedToCart) || 'liegt im Warenkorb!'));
        openCart();
      }
    });
  });

  /* ---------- Ankersprung nachziehen ----------
     Der Browser springt zum Anker, sobald das HTML da ist — die Bilder darüber
     sind dann oft noch nicht geladen. Sobald sie einlaufen, verschiebt sich das
     Layout und man landet doch wieder oben. Deshalb nach dem vollständigen Laden
     nochmal ansteuern.
  --------------------------------------------------- */
  if (location.hash && location.hash.length > 1) {
    const ankerZiel = (() => {
      try { return document.querySelector(location.hash); } catch (e) { return null; }
    })();

    if (ankerZiel) {
      let aufgeben = false;

      // Sobald jemand selbst scrollt, tippt oder tippt: Finger weg. Nichts ist
      // ärgerlicher als eine Seite, die einem den Scrollbalken aus der Hand nimmt.
      const stopp = () => { aufgeben = true; };
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(ev =>
        window.addEventListener(ev, stopp, { passive: true, once: true })
      );

      const anpeilen = () => {
        if (aufgeben || !ankerZiel.isConnected) return;
        ankerZiel.scrollIntoView({ block: 'start' });
      };

      // Sofort, dann mehrfach nachziehen, solange sich das Layout noch setzt
      // (nachladende Bilder, Schriften, Apps). Jeder Aufruf ist folgenlos,
      // wenn die Position bereits stimmt.
      anpeilen();
      [80, 250, 600, 1200, 2000].forEach(ms => setTimeout(anpeilen, ms));
      window.addEventListener('load', anpeilen, { once: true });

      // Bilder oberhalb des Ziels verschieben das Layout am stärksten
      document.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', anpeilen, { once: true });
      });
    }
  }

  /* ---------- Merkzettel (Favoriten) ----------
     Speichert im Browser des Besuchers. Kein Konto nötig, dafür gerätegebunden.
     Wird später eine Wunschlisten-App installiert, übernimmt diese — dann
     einfach die [data-wish]-Buttons durch die der App ersetzen.
  --------------------------------------------------- */
  const WISH_KEY = 'fabians-favoriten';

  function wishRead() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISH_KEY));
      return Array.isArray(raw) ? raw.filter(h => typeof h === 'string') : [];
    } catch (e) { return []; }
  }
  function wishWrite(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* Privatmodus */ }
  }
  function wishHas(handle) { return wishRead().indexOf(handle) !== -1; }

  function wishRenderCount() {
    const n = wishRead().length;
    document.querySelectorAll('[data-wish-count]').forEach(el => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function wishRenderButtons() {
    const list = wishRead();
    document.querySelectorAll('[data-wish]').forEach(btn => {
      btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-wish')) !== -1 ? 'true' : 'false');
    });
  }

  function wishToggle(handle) {
    const list = wishRead();
    const i = list.indexOf(handle);
    const added = i === -1;
    if (added) { list.push(handle); } else { list.splice(i, 1); }
    wishWrite(list);
    wishRenderButtons();
    wishRenderCount();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle, added, list } }));
    return added;
  }

  window.themeWishlist = { read: wishRead, toggle: wishToggle, has: wishHas };

  document.querySelectorAll('[data-wish]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.getAttribute('data-wish');
      const added = wishToggle(handle);
      const T = window.themeStrings || {};
      if (added) {
        btn.classList.add('just-added');
        setTimeout(() => btn.classList.remove('just-added'), 400);
        toast(T.wishAdded || 'Gemerkt!');
      } else {
        toast(T.wishRemoved || 'Von der Merkliste entfernt');
      }
    });
  });

  wishRenderButtons();
  wishRenderCount();

  /* ---------- Product gallery ---------- */
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const full = thumb.getAttribute('data-full');
        if (mainImg && full) { mainImg.src = full; }
      });
    });
  }

  /* ---------- Variant selection ---------- */
  const variantForm = document.querySelector('[data-variant-root]');
  if (variantForm) {
    const variants = JSON.parse(variantForm.getAttribute('data-variants') || '[]');
    const idInput = variantForm.querySelector('[data-variant-id]');
    const priceEl = variantForm.querySelector('[data-variant-price]');
    const unitPriceEl = variantForm.querySelector('[data-variant-unit-price]');
    let unitPrices = {};
    try { unitPrices = JSON.parse(variantForm.getAttribute('data-unit-prices') || '{}'); } catch (e) { unitPrices = {}; }
    const addBtn = variantForm.querySelector('[data-add-btn]');
    const addLabel = addBtn && addBtn.querySelector('[data-btn-label]');
    const soldNote = variantForm.querySelector('[data-soldout]');
    const galleryRoot = document.querySelector('[data-gallery]');
    const T = window.themeStrings || {};

    function selectedOptions() {
      const opts = [];
      variantForm.querySelectorAll('[data-option-index]').forEach(group => {
        const checked = group.querySelector('input:checked');
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
      });
      return opts;
    }
    function matchVariant() {
      const opts = selectedOptions();
      return variants.find(v => v.options.every((o, i) => o === opts[i])) || null;
    }
    function update() {
      const v = matchVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (unitPriceEl) {
        const up = unitPrices[v.id] || '';
        unitPriceEl.textContent = up;
        unitPriceEl.hidden = up === '';
      }
      const available = v.available;
      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? (T.addToCart || 'Einpacken lassen') : (T.soldOut || 'Ausverkauft');
      if (soldNote) soldNote.hidden = available;
      if (v.featured_image && galleryRoot) {
        const mainImg = galleryRoot.querySelector('[data-gallery-main] img');
        if (mainImg) mainImg.src = v.featured_image.src || v.featured_image;
      }
    }
    variantForm.querySelectorAll('[data-option-index] input').forEach(i => i.addEventListener('change', update));
    update();
  }

  /* ---------- Quantity steppers (PDP) ---------- */
  document.querySelectorAll('[data-qty-box]').forEach(box => {
    const input = box.querySelector('input');
    box.querySelector('[data-qty-dec]').addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    box.querySelector('[data-qty-inc]').addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ---------- Scroll reveal ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    // threshold 0 statt eines Prozentwerts: ein prozentualer Schwellwert kann von
    // Elementen, die höher sind als der Viewport, nie erreicht werden — sie blieben
    // dauerhaft unsichtbar (z. B. lange Rechtstexte).
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

    reveals.forEach(r => {
      // Sehr lange Blöcke gar nicht erst animieren — Inhalt geht vor Effekt.
      if (r.getBoundingClientRect().height > window.innerHeight) {
        r.classList.add('in');
      } else {
        io.observe(r);
      }
    });
  } else {
    reveals.forEach(r => r.classList.add('in'));
  }

  /* ---------- Category carousel ---------- */
  document.querySelectorAll('[data-cat-track]').forEach(track => {
    const wrap = track.closest('[data-carousel]');
    if (!wrap) return;
    const prev = wrap.querySelector('[data-cat-prev]');
    const next = wrap.querySelector('[data-cat-next]');
    const amount = () => Math.max(240, Math.round(track.clientWidth * 0.8));
    function update() {
      const overflow = track.scrollWidth > track.clientWidth + 4;
      wrap.classList.toggle('has-overflow', overflow);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Init cart count on load ---------- */
  refreshCart();
})();
